import { localUrlSwitcher } from './local-util';
import { supportedLanguages } from '@shared/utils/languages';

export const languages = supportedLanguages;

export function changeUrlToLanguage(code: string) {
  // For development (localhost), we switch ports (remember to start the servers)
  if (window.location.hostname === 'localhost') {
    localUrlSwitcher(code);
    return;
  }

  // In production, the builds are in subfolders like /en/ and /da/
  const currentPathname = window.location.pathname;
  const languagePattern = new RegExp(`^/(${languages.map(({ code }) => code).join('|')})(?=/|$)`);
  const pathWithoutLanguage = currentPathname.replace(languagePattern, '') || '/';
  const targetPath = `/${code}${pathWithoutLanguage === '/' ? '' : pathWithoutLanguage}`;
  window.location.href = targetPath;
}
